
import { message } from "antd"; 
import { APIURL } from "./api";
import { deleteCookie, getCookie } from "./utll";

export async function apiRequest(method, endpoint, body = null) {
  const token = getCookie("token");

  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `${token}` : "",
    },
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${APIURL}${endpoint}`, options);

    // ****** HANDLE 401 -> SESSION EXPIRED ******
    if (response.status === 401) {
      message.warning("⚠️ Session expired. Please login again.");

      // Clear all login-related cookies
      deleteCookie("auth");
      deleteCookie("userDetail");
      deleteCookie("token");

      setTimeout(() => {
        window.location.href = "/login";
      }, 800);

      return null;
    }

    // Handle other server errors
    if (!response.ok) {
      const text = await response.text();
      message.error(text || "Something went wrong");
      return null;
    }

    return await response.json();
  } catch (err) {
    console.error("API Request Failed:", err);
    message.error("Network error — please check your connection.");
    return null;
  }
}
